import React from 'react';

const AuthFeaturesSection: React.FC = () => {
    return (
        <div className="flex-1 text-white space-y-8 animate-fade-in text-center lg:text-left">
            <div>
                <h1 className="text-5xl lg:text-6xl font-bold tracking-wider mb-4">
                    RaceLine<span className="text-cyan-400">IQ</span>
                </h1>
                <p className="text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto lg:mx-0">
                    Don't just train harder. Race smarter.
                </p>
            </div>

            <div className="pt-4">
                <h2 className="text-2xl font-semibold text-white mb-6 border-b border-gray-700 pb-2 inline-block">
                    Features overview
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-left">
                    <div className="bg-gray-800/50 p-5 rounded-xl border border-gray-700 backdrop-blur-md hover:bg-gray-800/70 transition-colors">
                        <div className="w-10 h-10 bg-cyan-500/20 rounded-lg flex items-center justify-center mb-4 border border-cyan-500/30">
                            <svg className="w-5 h-5 text-cyan-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <h3 className="text-lg font-bold text-white mb-2">Playback Engine</h3>
                        <p className="text-sm text-gray-300">Review races with not just you but everyone else.</p>
                        <p className="text-xs text-gray-500 mt-2">*Only racers who add their event files to RaceLineIQ will show up.</p>
                    </div>

                    <div className="bg-gray-800/50 p-5 rounded-xl border border-gray-700 backdrop-blur-md hover:bg-gray-800/70 transition-colors">
                        <div className="w-10 h-10 bg-blue-500/20 rounded-lg flex items-center justify-center mb-4 border border-blue-500/30">
                            <svg className="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                            </svg>
                        </div>
                        <h3 className="text-lg font-bold text-white mb-2">Automatic Cataloging</h3>
                        <p className="text-sm text-gray-300">Your race file is placed in the correct race for you automatically.</p>
                        <p className="text-xs text-gray-500 mt-2">*Requires account integration.</p>
                    </div>

                    <div className="bg-gray-800/50 p-5 rounded-xl border border-gray-700 backdrop-blur-md hover:bg-gray-800/70 transition-colors">
                        <div className="w-10 h-10 bg-indigo-500/20 rounded-lg flex items-center justify-center mb-4 border border-indigo-500/30">
                            <svg className="w-5 h-5 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                            </svg>
                        </div>
                        <h3 className="text-lg font-bold text-white mb-2">Drafting Analytics</h3>
                        <p className="text-sm text-gray-300">See how much time you spent in the draft and how much energy you saved.</p>
                    </div>

                    <div className="bg-gray-800/50 p-5 rounded-xl border border-gray-700 backdrop-blur-md hover:bg-gray-800/70 transition-colors">
                        <div className="w-10 h-10 bg-purple-500/20 rounded-lg flex items-center justify-center mb-4 border border-purple-500/30">
                            <svg className="w-5 h-5 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                            </svg>
                        </div>
                        <h3 className="text-lg font-bold text-white mb-2">Performance Insights</h3>
                        <p className="text-sm text-gray-300">Get a full report on where you excelled or can improve your performance on race day.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(AuthFeaturesSection);
